export const TRANSFER_STEP_1 = 0;
export const TRANSFER_STEP_2 = 1;
export const TRANSFER_STEP_3 = 2;

const steps = {
  [TRANSFER_STEP_1]: {
    component: () =>
      import(
        /* webpackChunkName: "conduct-stocktake" */ '@/views/platform/venue/stock/inventory-transfer/Outlet.vue'
      ),
    title: 'Outlet',
    pageTitle: 'Please choose outlet',
    pageInfo: 'Please, select the outlet to which you would like to transfer items',
    nextCta: 'Next Step',
  },
  [TRANSFER_STEP_2]: {
    component: () =>
      import(
        /* webpackChunkName: "conduct-stocktake" */ '@/views/platform/venue/stock/inventory-transfer/Products.vue'
      ),
    title: 'Products',
    pageTitle: 'Select Products',
    pageInfo: 'Please, select the products that should be transferred.',
    nextCta: 'Go To Overview',
  },
  [TRANSFER_STEP_3]: {
    component: () =>
      import(
        /* webpackChunkName: "conduct-stocktake" */ '@/views/platform/venue/stock/inventory-transfer/Overview.vue'
      ),
    title: 'Overview',
    pageTitle: 'Overview',
    pageInfo:
      'Before completing the inventory transfer for the selected items, check the information below to confirm you have entered everything correctly.',
    nextCta: 'Finish',
  },
};

export default steps;
